<template>
  <div id="product-browse">
    <div id="product-category-selection-wrapper" class="noto-sans-sc-font-family">
      <div id="product-category-selection" class="text-center">
        <v-menu offset-y nudge-bottom="-10px" nudge-left="13px">
          <template v-slot:activator="{ on }">
            <div
              v-on="on"
              id="category-selection-btn"
              class="category-selection d-inline-block py-4"
            >
              {{ selectedCategoryDislayLabel }}
              <v-icon color="#e2211c">keyboard_arrow_down</v-icon>
            </div>
          </template>
          <div class="text-center">
            <div
              class="noto-sans-sc-font-family category-selection py-3 px-6"
              v-for="(category, index) in unselectedCategory"
              @click="updateCategory(category)"
              :key="index"
            >{{ category.name}}</div>
          </div>
        </v-menu>
      </div>
    </div>
    <div
      id="product-subcategory-selection-wrapper"
      class="noto-sans-sc-font-family text-center py-2"
    >
      <div
        v-if="selectedSubcategory"
        @click.stop="showProductSubcategorySelection = !showProductSubcategorySelection"
      >
        {{ selectedSubcategoryDislayLabel }}
        <v-icon color="#e2211c">keyboard_arrow_down</v-icon>
      </div>
      <div
        v-else
        @click.stop="showProductSubcategorySelection = !showProductSubcategorySelection"
      >Select Product Category</div>
      <transition name="slide-fade">
        <div
          id="product-subcategory-selection-list"
          class="elevation-3"
          v-show="showProductSubcategorySelection"
        >
          <div
            class="product-subcategory d-flex justify-center align-center my-1 px-3 py-2"
            v-for="(subcategory, index) in unselectedSubcategory"
            @click.stop="updateSubcategory(subcategory)"
            :key="index"
          >{{ subcategory.name }}</div>
        </div>
      </transition>
    </div>
    <div id="search-results-wrapper" class="main-content-width mx-auto mb-12">
      <transition name="slide-fade" mode="out-in">
        <div
          v-if="hasNoSearchResult"
          class="text-center noto-sans-sc-font-family mt-6"
          key="NoResult"
        >
          <div id="search-result-hint" class="search-hint px-2">{{ searchResultHintText }}</div>
          <div id="search-result-full-hint" class="search-hint px-2">{{ searchResultFullHintText }}</div>
        </div>
        <v-row
          v-if="hasSearchResult"
          no-gutters
          key="hasResult"
          class="px-sm-2 px-md-0 justify-space-around justify-sm-start"
        >
          <v-divider></v-divider>

          <v-col
            v-for="(product, index) in products"
            :key="index"
            class="product-card-wrapper"
            cols="6"
          >
            <product-card
              :title="product.tinyTitle"
              :imageSrc="getProductImage(product.id, product.images[0])"
              :displayPrice="product.amazonListings[0].displayPrice"
              :rating="rating"
              :id="product.id"
            ></product-card>
            <v-divider></v-divider>
          </v-col>
        </v-row>
      </transition>
    </div>
    <a href="#top" id="back-to-top-section">
      <v-icon color="#9a9a9a">keyboard_arrow_up</v-icon>
    </a>
  </div>
</template>

<script>
import router from "../../plugins/router";
import ProductCard from "../components/mobile/ProductCard";
import productBrowseMixins from "../../mixins/productBrowseMixins";

export default {
  components: {
    ProductCard
  },
  mixins: [productBrowseMixins],

  data: () => ({
    showProductSubcategorySelection: false
  }),
  created() {
    this.initData();
  },

  methods: {
    updateSubcategory(subcategory) {
      if (this.selectedSubcategory != subcategory.term) {
        this.showProductSubcategorySelection = false;
        this.selectedSubcategory = subcategory.term;
        router.push({
          path: "/product/browse",
          // path: "/product",
          query: { c: this.selectedCategory, sc: this.selectedSubcategory }
        });
      }
    }
  },
  computed: {
    unselectedSubcategory() {
      return this.productSubcategory.filter(
        c => c.term != this.selectedSubcategory
      );
    },
    selectedSubcategoryDislayLabel() {
      return this.productSubcategory.find(
        category => category.term == this.selectedSubcategory
      ).name;
    }
  }
};
</script>

<style scoped>
#product-browse {
  width: 100%;
}

#product-category-selection {
  border-bottom: 1px solid #e6e6e6;
  border-top: 1px solid #e6e6e6;
}

.category-selection {
  color: #333333;
  cursor: pointer;
  background-color: white;
}

.v-menu__content {
  box-shadow: none;
  border: 1px #dadada solid;
  z-index: 1 !important;
}

#search-results-wrapper {
  position: relative;
}

.product-card-wrapper:nth-child(1) {
  border-top: 1px solid #e5e5e5;
}

.product-card-wrapper:nth-child(odd) {
  border-left: 1px solid #e5e5e5;
}

#product-subcategory-selection-wrapper {
  border-bottom: 1px solid #e5e5e5;
  color: #333333;
  position: relative;
}

#product-subcategory-selection-list {
  position: absolute;
  top: 41px;
  z-index: 2;
  background-color: white;
  width: 100%;
}

.product-subcategory {
  border-bottom: 1px solid #e5e5e5;
  font-size: 12px;
}

#back-to-top-section {
  border: 1px solid #9a9a9a;
  border-radius: 5px;
  position: absolute;
  bottom: 5px;
  right: 15px;
  padding: 3px;
}
</style>
